export const STATIC_LOCATIONS = [
  "India",
  "Agartala, India",
  "Agra, India",
  "Ahmedabad, India",
  "Ahmednagar, India",
  "Ajmer, India",
  "Akola, India",
  "Alappuzha, India",
  "Aligarh, India",
  "Alwar, India",
  "Amravati, India",
  "Amritsar, India",
  "Anand, India",
  "Aurangabad, India",
  "Bangalore, India",
  "Bardhaman, India",
  "Bareilly, India",
  "Belgaum, India",
  "Bhavnagar, India",
  "Bhilai, India",
  "Bhilwara, India",
  "Bhopal, India",
  "Bikaner, India",
  "Bilaspur, India",
  "Chandigarh, India",
  "Chennai, India",
  "Coimbatore, India",
  "Cuttack, India",
  "Dehradun, India",
  "Delhi, India",
  "Dhanbad, India",
  "Erode, India",
  "Faridabad, India",
  "Gandhinagar, India",
  "Ghaziabad, India",
  "Gorakhpur, India",
  "Gurgaon, India",
  "Guwahati, India",
  "Gwalior, India",
  "Haridwar, India",
  "Hyderabad, India",
  "Indore, India",
  "Jabalpur, India",
  "Jaipur, India",
  "Jalandhar, India",
  "Jalgaon, India",
  "Jammu, India",
  "Jamnagar, India",
  "Jamshedpur, India",
  "Jhansi, India",
  "Jodhpur, India",
  "Kanpur, India",
  "Karnal, India",
  "Kochi, India",
  "Kolhapur, India",
  "Kolkata, India",
  "Kollam, India",
  "Kottayam, India",
  "Kozhikode, India",
  "Lucknow, India",
  "Ludhiana, India",
  "Madurai, India",
  "Mangalore, India",
  "Mathura, India",
  "Meerut, India",
  "Moradabad, India",
  "Morena, India",
  "Mumbai, India",
  "Muzaffarpur, India",
  "Nagpur, India",
  "Nanded, India",
  "Nashik, India",
  "New Delhi, India",
  "Old Delhi, India",
  "Noida, India",
  "Greater Noida, India",
  "Pali, India",
  "Panipat, India",
  "Patiala, India",
  "Patna, India",
  "Prayagraj, India",
  "Pune, India",
  "Raipur, India",
  "Rajkot, India",
  "Rampur, India",
  "Ranchi, India",
  "Ratlam, India",
  "Rohtak, India",
  "Saharanpur, India",
  "Salem, India",
  "Sangli, India",
  "Satara, India",
  "Satna, India",
  "Secunderabad, India",
  "Shimla, India",
  "Thiruvananthapuram, India",
  "Udaipur, India",
  "Ujjain, India",
  "Vadodara, India",
  "Varanasi, India",
  "Vellore, India",
  "Visakhapatnam, India"
];